import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.sessions.table.dataPoints);
  const isUserQa = useSelector((state) => state.sessions.currentUser.isUserQa);
  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              value={dataPoint.value}
              url={dataPoint.link}
              disableAnimation={isUserQa}
              type="default"
              decimal={dataPoint.decimal}
            />
          </div>
        );
      })}
    </div>
  );
});
